var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1201,
    height: 1200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: -4,
    width: 1201,
    height: 1200
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 371,
    width: 618,
    height: 618
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 371,
    width: 618,
    height: 618
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 371,
    width: 618,
    height: 618
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-114 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132 597.5C132 274.69 393.69 13.0001 716.5 13.0001 1039.31 13.0001 1301 274.69 1301 597.5 1301 920.311 1039.31 1182 716.5 1182 393.69 1182 132 920.311 132 597.5Z",
    stroke: "#D9D9D9",
    strokeWidth: 27.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506 325C506 213.991 595.991 124 707 124L707 124C818.009 124 908 213.991 908 325L908 732C908 843.009 818.009 933 707 933 595.991 933 506 843.009 506 732Z",
    fill: "#404040",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 326C587 260.83 639.831 208 705 208L705 208C770.17 208 823 260.83 823 326L823 621C823 686.17 770.17 739 705 739 639.831 739 587 686.17 587 621Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.5 488.011C385.5 445.203 420.203 410.5 463.01 410.5L969.989 410.5C1012.8 410.5 1047.5 445.203 1047.5 488.011L1047.5 911.989C1047.5 954.797 1012.8 989.5 969.989 989.5L463.01 989.5C420.203 989.5 385.5 954.797 385.5 911.989Z",
    stroke: "#404040",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#404040",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M845.042 566.098C829.617 566.098 816.763 553.244 817.405 537.176 817.405 521.751 830.259 508.897 845.684 508.897 861.109 508.897 873.964 521.751 873.964 537.176 873.964 544.888 870.75 551.958 865.608 557.1 859.824 562.884 852.754 566.098 845.042 566.098ZM817.405 476.761C803.266 481.903 792.34 492.829 785.27 505.683 776.272 523.036 774.987 542.96 782.056 560.956L812.906 627.798 833.473 670.217C835.401 674.716 839.9 677.286 845.042 677.286 850.183 677.286 854.682 674.716 856.61 670.217L877.177 627.798 908.027 561.599C911.241 553.886 912.526 545.531 912.526 537.176 912.526 492.186 866.251 458.123 817.405 476.761Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.646 839.892 600.813 788.475 600.813 578.952 703.646 630.369 703.646 839.892ZM575.104 788.475 497.979 827.037 497.979 617.515 575.104 578.952 575.104 788.475ZM931.165 572.525 915.097 607.231 935.021 617.515 935.021 827.037 857.896 788.475 857.896 702.995 832.188 702.995 832.188 788.475 729.354 839.892 729.354 630.369 774.987 607.231 758.919 572.525 716.5 593.734 587.958 529.464 459.417 593.734 459.417 889.38 587.958 825.109 716.5 889.38 845.042 825.109 973.583 889.38 973.583 593.734 931.165 572.525Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 320,
    width: 117,
    height: 87,
    fill: "#FFFFFF",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapUnlocked);
export default __webpack_public_path__ + "static/media/map-unlocked.38a7af5b336a6146325afe1d7e333286.svg";
export { ForwardRef as ReactComponent };